/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router';
import {
    StandardIcon
}
from '../../components/SVGIcon';
import BackBar from '../../components/BackBar';
import Header from './components/Header.js';
import Localized from '../../../shared/components/Localized';
import StatusGridView from './components/StatusGridView';
import styles from '../../styles';
import LoadingSpinner from '../../components/Spinners/LoadingSpinner';

import { Wrapper, Pane } from './styles';
import styled from 'styled-components';

const PaddedIcon = styled.div`
  margin: 0 1rem 0 0;
`;

const Bar = styled.div`
  border: 1px solid ${styles.colors.linkWater};
  margin: 1rem;
`;

class Search extends React.Component {
  constructor(props) {
    super(props);

    this.resetSearchBox = () => {
      this.props.setSearchBoxValue('');
      this.props.showMobileSearch(false);
    }
  }

  static propTypes = {
    match: PropTypes.shape({
      url: PropTypes.string,
      path: PropTypes.string
    }),
    requests: PropTypes.object,
  }


  render() {
    const { requests } = this.props;
    const allLocalizations = requests.hasOwnProperty('localizations') && requests.localizations.value || [];
    const itemString = allLocalizations.length ? allLocalizations.filter(l=> l.modelKey && l.modelKey==='item' && l.modelAttribute ==='label')[0].text : 'item'; 
    const itemsString = allLocalizations.length ? allLocalizations.filter(l=> l.modelKey && l.modelKey==='items' && l.modelAttribute ==='label')[0].text : 'items';

    if (!requests.searchResults.isCompleted ||
      !requests.instances.isCompleted) return <LoadingSpinner />;
    const searchResults = requests.searchResults.response.body;
    const sResults = searchResults.filter(item => item.aliasType != 'orgId');
    const iResults = requests.instances.response.body;

    const arr = [];
    let myDomains = [];
    let myMids = [];
    let midCount =0;
    let domainCount =0;
    let customCount = 0;
    let notActiveCount = 0;
    for (let i = sResults.length - 1; i >= 0; i--) {
       
      const _instance = iResults
        .filter((_inst) => (_inst.key === sResults[i].key) ||
          (_inst.key === sResults[i].instanceKey))[0];

      if (typeof (_instance) === 'undefined') continue;

      const copy = JSON.parse(JSON.stringify(_instance));

      // check for custom domain
       
      if (sResults[i].alias) {
        customCount += 1;
        if(sResults[i].aliasType === 'domain') domainCount +=1;
        if(sResults[i].aliasType === 'mid') midCount+=1;
        copy.alias = sResults[i].alias;  
        copy.aliasType = sResults[i].aliasType;
        arr.push(copy);
      } else if (!sResults[i].isActive) {
        notActiveCount += 1;
      }
      else {
        arr.push(_instance);
      }
       myDomains = arr.filter( item=> (!item.aliasType || item.aliasType === 'domain') && item.alias );
       myMids = arr.filter(item => item.aliasType === 'mid' && item.alias);
  }

    const instanceKeysCount = sResults.length - customCount - notActiveCount;
    const instanceKeysStr = instanceKeysCount.toString() +  (instanceKeysCount > 1 ? ` ${itemsString}` : ` ${itemString}`);
    const overallResultsStr = arr.length.toString() +  (arr.length > 1 ? ` ${itemsString}` : ` ${itemString}`);

    return (
      <Wrapper>
        <BackBar onClick={ this.resetSearchBox } />
        <Pane>
          <Header
            shaded={true}
            subText={overallResultsStr}
            mainText={ <Localized modelKey='searchResults' modelAttribute='label' modelName='search' /> }
            pageHeader={true}
          >
          <PaddedIcon>
            <StandardIcon icon='search' bgColor={ styles.colors.darkBlue }
              size='3rem' round />
          </PaddedIcon>
          </Header>
          { customCount > 0 && myDomains.length !== 0  &&
            <div>
              <Header
                subText= {`${domainCount} ${itemString}`}
                mainText={ <Localized modelKey='myDomains' modelAttribute='label' modelName='search' /> }
              >
                <PaddedIcon>
                  <StandardIcon icon='orders' bgColor={ styles.colors.turquoise }
                    size='2rem' round />
                </PaddedIcon>
              </Header>
              <StatusGridView
                onInstanceClicked={ this.resetSearchBox }
                instanceGroups={ myDomains }
              />
              <Bar/>
            </div>
          }
          { customCount > 0 && myMids.length !==0 &&
            <div>
              <Header
                subText= {`${midCount} ${itemString}`}
                mainText={ <Localized modelKey='myMids' modelAttribute='label' modelName='search' /> }
              >
                <PaddedIcon>
                  <StandardIcon icon='orders' bgColor={ styles.colors.turquoise }
                    size='2rem' round />
                </PaddedIcon>
              </Header>
              <StatusGridView
                onInstanceClicked={ this.resetSearchBox }
                instanceGroups={ myMids }
              />
              <Bar/>
            </div>
          }
          { instanceKeysCount > 0 && <div>
            <Header
              subText= { instanceKeysStr }
              mainText={ <Localized modelKey='instances' modelAttribute='label' modelName='tabs' /> }
            >
              <PaddedIcon>
                <StandardIcon icon='orders' bgColor={ styles.colors.turquoise }
                  size='2rem' round />
              </PaddedIcon>
            </Header>
            <StatusGridView
              onInstanceClicked={ this.resetSearchBox }
              instanceGroups={ arr.filter((inst) => !inst.alias) }
            />
          </div>
        }
        { instanceKeysCount === 0 && arr.length === 0 &&
          <Header><Localized modelKey='noResultsFound' modelAttribute='label' modelName='search' /></Header> }
        </Pane>
      </Wrapper>
    );
  }
}

export default Search;
